import type { CharterLoyaltyPointMultiplierFilters } from '~/components/Flights/Charter/charter.types';

export const charterLoyaltyPointMultiplierQueryKeys = {
  all: ['flights-charter', 'loyalty-point-multipliers'] as const,
  lists: () => [...charterLoyaltyPointMultiplierQueryKeys.all, 'list'] as const,
  list: (filters: CharterLoyaltyPointMultiplierFilters) =>
    [...charterLoyaltyPointMultiplierQueryKeys.lists(), filters] as const,
};
